<div class="flight-search-results__container">
  @if (flight) {
    <div class="flex-row-container flight-search-results__ticket-container">
      @if (!showLegs) {
        <div
          class="flex-column-container flight-search-results__ticket-details"
          [ngClass]="{ 'show-fares-block': showFaresBlock }"
        >
          <app-flight-header
            class="flight-header-border"
            [flightJourney]="flight.outboundFlights[0]"
            [lastFlightJourney]="lastOutboundFlightJourney"
            [allJourneys]="flight.outboundFlights"
            [source]="flight.source"
            [duration]="flight.outboundTotalDuration"
            (displayLegs)="showLegs = $event"
            [preferred]="flight?.preferred"
            [preferenceLevel]="flight?.preferenceLevel"
            [preferredMessages]="flight?.preferredMessages"
            [tmcPreferredLogoUrl]="flight?.tmcPreferredLogoUrl"
            [searchType]="searchService.searches[ServiceType.Flight]?.chosenSearchType"
          >
          </app-flight-header>
          @if (
            searchService.searches[ServiceType.Flight].isReturn && !isDualFlight && !isDualReturn
          ) {
            <app-flight-header
              [flightJourney]="flight.inboundFlights[0]"
              [lastFlightJourney]="lastInboundFlightJourney"
              [allJourneys]="flight.inboundFlights"
              [source]="flight.source"
              [isReturn]="true"
              [duration]="flight.inboundTotalDuration"
              [searchType]="searchService.searches[ServiceType.Flight]?.chosenSearchType"
            >
            </app-flight-header>
          }
        </div>
      }
      <div
        class="flex-column-container fare-container"
        [ngStyle]="{ minWidth: searchParams.bySchedule ? '10%' : '30%' }"
      >
        @for (combinedFlight of combinedFlight.flights; track combinedFlight; let j = $index) {
          @if (!searchParams.bySchedule) {
            @if (j <= 2) {
              <div
                id="fare-wrapper-{{ flightIndex }}-{{ j }}"
                class="flex-row-container fare-wrapper"
              >
                <div class="flight-fares">
                  <span class="cabin-class">
                    {{ combinedFlight.outboundFlights[0].cabinClass | splitCamelCase | translate }}
                    @if (combinedFlight.outboundFlights[0].additional.fareBrand?.name) {
                      <span>
                        ({{
                          combinedFlight.outboundFlights[0].additional.fareBrand?.name | titlecase
                        }})</span
                      >
                    }
                    @if (showAltClass(combinedFlight)) {
                      <span
                        >/<br />{{
                          combinedFlight.inboundFlights[0].cabinClass | splitCamelCase | translate
                        }}</span
                      >
                    }
                  </span>
                  @if (allHiddenStops.length) {
                    <section class="container" (mouseleave)="tt.close()">
                      <a
                        id="hidden_stops"
                        [ngbTooltip]="hiddenStopsTooltip"
                        triggers="manual"
                        placement="top"
                        #tt="ngbTooltip"
                        (mouseenter)="tt.open()"
                        (focus)="tt.open()"
                        (blur)="tt.close()"
                        tabindex="0"
                      >
                        <i class="currency_info_icon"></i>
                        <span i18n="@@hiddenStop"> Hidden Stop</span>
                      </a>
                    </section>
                  }
                  @if (
                    showMixedCabin(combinedFlight.outboundFlights) ||
                    showMixedCabin(combinedFlight.inboundFlights)
                  ) {
                    <app-mixed-cabin-tooltip
                      [flights]="combinedFlight.outboundFlights"
                      [inboundFlights]="combinedFlight?.inboundFlights"
                    ></app-mixed-cabin-tooltip>
                  }
                </div>
                @if (showSpecialFares(combinedFlight)) {
                  <div class="special-fares-container">
                    <app-special-fare-icon [flight]="combinedFlight"></app-special-fare-icon>
                  </div>
                }
                @if (combinedFlight.source.toUpperCase().includes('NDC')) {
                  <div class="ndc-fare">NDC</div>
                }
                <div
                  class="flex-row-container flight-search-results__ticket-button-icons price-wrapper"
                  [ngStyle]="{
                    'padding-right.px':
                      !combinedFlight?.requiresReasonKeys?.length && !combinedFlight?.unavailable
                        ? 30
                        : 0
                  }"
                >
                  <div
                    class="flex-row-container"
                    #tooltipRef="ngbTooltip"
                    triggers="manual"
                    [ngbTooltip]="
                      combinedFlight.source.toUpperCase().includes('NDC') ? 'NDC Fare' : null
                    "
                    [placement]="combinedFlight.source.toUpperCase().includes('NDC') ? 'top' : null"
                    [container]="
                      combinedFlight.source.toUpperCase().includes('NDC') ? 'body' : null
                    "
                  >
                    @if (
                      !(
                        isExchange &&
                        (combinedFlight?.source === 'Sabre Flights' ||
                          combinedFlight?.source === 'Sabre') &&
                        !loadingHideExchangePriceSabre &&
                        hideExchangePriceSabre &&
                        !userIsAgent
                      )
                    ) {
                      <section
                        class="flex-row-container"
                        [ngbTooltip]="
                          combinedFlight.source.toUpperCase().includes('NDC') ? 'NDC Fare' : null
                        "
                        [placement]="
                          combinedFlight.source.toUpperCase().includes('NDC') ? 'top' : null
                        "
                        [container]="
                          combinedFlight.source.toUpperCase().includes('NDC') ? 'body' : null
                        "
                      >
                        @if (isExchange) {
                          <span>{{ combinedFlight.total.price > 0 ? '+' : '' }}</span>
                        }
                        <span class="flight-search-results__ticket-button-price" id="price">
                          {{ combinedFlight.total.price | currency: flight.total.currency }}
                        </span>
                      </section>
                    }
                  </div>
                  @if (!isExchange || isPricingExchange) {
                    <div class="flight-baggage" id="flight-baggage-{{ flightIndex }}-{{ j }}">
                      <!-- Use ng-container to declare variables -->
                      <ng-container
                        [ngTemplateOutlet]="baggageTemplate"
                        [ngTemplateOutletContext]="{
                          outboundBaggage: searchParams.getTotalBaggage(combinedFlight),
                          inboundBaggage: searchParams.getTotalBaggage(combinedFlight, false)
                        }"
                      >
                      </ng-container>
                      <!-- Template to display baggage information -->
                      <ng-template
                        #baggageTemplate
                        let-outboundBaggage="outboundBaggage"
                        let-inboundBaggage="inboundBaggage"
                      >
                        <b>
                          <!-- Display outbound baggage -->
                          <span>
                            {{ outboundBaggage }}
                            @if (outboundBaggage !== 1) {
                              <span>
                                <span i18n="@@bags">bags</span>
                              </span>
                            } @else {
                              <span i18n="@@bag">bag</span>
                            }
                          </span>
                          <!-- Display inbound baggage if different -->
                          @if (
                            outboundBaggage !== inboundBaggage &&
                            searchParams.isReturn &&
                            !isDualFlight &&
                            !isDualReturn
                          ) {
                            <span>
                              / {{ inboundBaggage }}
                              @if (inboundBaggage !== 1) {
                                <span>
                                  <span i18n="@@bags">bags</span>
                                </span>
                              } @else {
                                <span i18n="@@bag">bag</span>
                              }
                            </span>
                          }
                        </b>
                      </ng-template>
                    </div>
                  }
                </div>
                <div class="flex-column-container">
                  <div class="flex-row-container book-wrapper">
                    @if (
                      (combinedFlight?.requiresReasonKeys?.length || combinedFlight?.unavailable) &&
                      !isUnavailableDueToTime
                    ) {
                      <div>
                        <app-warning-tags
                          iconId="{{ flightIndex }}-{{ j }}"
                          [ticket]="getFareRules(combinedFlight)"
                          [displayCheck]="false"
                        ></app-warning-tags>
                      </div>
                    }
                    @if (isUnavailableDueToTime) {
                      <section (mouseleave)="ttUnavailableIcon.close()" class="container">
                        <fa-icon
                          class="time_error_icon"
                          container="body"
                          triggers="manual"
                          #ttUnavailableIcon="ngbTooltip"
                          (mouseenter)="ttUnavailableIcon.open()"
                          ngbTooltip="Invalid Selection: you cannot select a time that leaves before the departing journey has arrived, please choose an alternative."
                          i18n-ngbTooltip
                          attr.aria-label="Invalid Selection: you cannot select a time that leaves before the departing journey has arrived, please choose an alternative."
                          (focus)="ttUnavailableIcon.open()"
                          (blur)="ttUnavailableIcon.close()"
                          tabindex="0"
                          [icon]="faCalendarExclamation"
                        />
                        <span class="visuallyhidden">
                          Invalid Selection: you cannot select a time that leaves before the
                          departing journey has arrived, please choose an alternative.
                        </span>
                      </section>
                    }
                    <!-- [disabled]="getFareRules(combinedFlight)?.unavailable" -->
                    @if (!isPricingExchange) {
                      <button
                        [ngClass]="{
                          'selected-button':
                            searchParams.selectedFlight.value &&
                            isDualFlight &&
                            !searchParams.fetchingRules
                        }"
                        [disabled]="
                          (combinedFlight?.unavailable && !canOverride) ||
                          (!searchParams.selectedFlight.value && isDualReturn) ||
                          isUnavailableDueToTime
                        "
                        (click)="checkDualClassAndSelect(combinedFlight)"
                        [attr.aria-label]="
                          searchParams.selectedFlight.value &&
                          isDualFlight &&
                          !searchParams.fetchingRules
                            ? 'Deselect '
                            : 'Select ' + getTicketSelectAriaLabel(combinedFlight)
                        "
                        class="small-button select-button"
                        id="flight-display-button-select-{{ flightIndex }}-{{ j }}"
                        (mouseenter)="tooltipRef.open()"
                        (mouseleave)="tooltipRef.close()"
                        (focus)="tooltipRef.open()"
                        (blur)="tooltipRef.close()"
                      >
                        <span>{{
                          (searchParams.selectedFlight.value &&
                          isDualFlight &&
                          !searchParams.fetchingRules
                            ? 'Deselect'
                            : isExchange &&
                                (combinedFlight?.source === 'Sabre Flights' ||
                                  combinedFlight?.source === 'Sabre')
                              ? 'Request'
                              : 'Select'
                          ) | translate
                        }}</span>
                        @if (
                          searchParams.fetchingRules &&
                          combinedFlight.journeyHash === searchParams.selectedUId
                        ) {
                          <app-loading-spinner size="sm" />
                        }
                      </button>
                    }
                    @if (checkIfSpanishResidencyApplies(combinedFlight)) {
                      <button
                        appButton="small"
                        class="select-button spanish_button"
                        [ngClass]="{
                          'selected-button': combinedFlight.total.discount
                        }"
                        [disabled]="combinedFlight.total.discount"
                        i18n="@@ResidentDiscount"
                        (click)="searchParams.repriceFlight(combinedFlight)"
                      >
                        Resident Discount
                      </button>
                    }
                  </div>
                  @if (combinedFlight.co2PerItem) {
                    <div class="flight_leg_co2" id="co2-{{ flightIndex }}-{{ j }}">
                      {{ combinedFlight.co2PerItem }} <span i18n="@flight_kg">kg</span>&nbsp;<span
                        i18n="@flight_leg_co2"
                        >CO</span
                      ><sub i18n="@flight_leg_2">2</sub>&nbsp;<span i18n="@flight_pp">pp</span>
                    </div>
                  }
                  <!-- [disabled]="getFareRules(combinedFlight)?.unavailable" -->
                </div>
              </div>
            }
          } @else {
            @if (j <= 0) {
              <div class="flex-row-container">
                <div
                  class="flex-column-container fare-wrapper"
                  [ngStyle]="{ alignItems: 'center' }"
                >
                  <div class="flex-row-container book-wrapper">
                    @if (combinedFlight?.requiresReason || combinedFlight?.unavailable) {
                      <div>
                        <app-warning-tags
                          iconId="{{ flightIndex }}-{{ j }}"
                          [ticket]="getFareRules(combinedFlight)"
                          [displayCheck]="false"
                        ></app-warning-tags>
                      </div>
                    }
                    <button
                      [disabled]="(disableItems && !deselectItem) || combinedFlight?.unavailable"
                      (click)="selectedMultiCityByScheduleFlight(combinedFlight)"
                      [attr.aria-label]="
                        deselectItem
                          ? 'Deselect '
                          : 'Select ' + getTicketSelectAriaLabel(combinedFlight)
                      "
                      appButton="small"
                      class="select-button"
                      id="flight-display-button-select-{{ flightIndex }}-{{ j }}"
                    >
                      <span>{{ (deselectItem ? 'Deselect' : 'Select') | translate }}</span>
                    </button>
                  </div>
                  @if (combinedFlight.co2PerItem) {
                    <div class="flight_leg_co2">
                      {{ combinedFlight.co2PerItem }} <span i18n="@flight_kg">kg</span>&nbsp;<span
                        i18n="@flight_leg_co2"
                        >CO</span
                      ><sub i18n="@flight_leg_2">2</sub>&nbsp;<span i18n="@flight_pp">pp</span>
                    </div>
                  }
                </div>
              </div>
            }
          }
        }
      </div>
    </div>
  }
  <!-- <span style="color: black">HERE {{flight.uid}}</span> -->
  @if (flight?.greenerChoice) {
    <section (mouseleave)="tt.close()" class="container">
      <div
        class="flightDetails_greenerChoice"
        placement="top"
        triggers="manual"
        [ngbTooltip]="greenChoiceTooltip"
        #tt="ngbTooltip"
        (mouseenter)="tt.open()"
        (focus)="tt.open()"
        (blur)="tt.close()"
        tabindex="0"
        attr.aria-label="{{
          themeService.isLightningEnv ? 'CTM ' : ''
        }}Greener Choice - This flight emits {{
          flight?.greenerChoicePercentage | greenerPercentage
        }}% less CO2 than the average for your search"
      >
        <img
          class="flightDetails_greenerChoiceLogo"
          src="https://images.sabscorp.com/images/logo/seedling.svg"
          alt="Greener Choice"
        />
        <div class="flightDetails_greenerChoiceText">
          @if (themeService.isLightningEnv) {
            <span i18n="@@flightDetails_greenerChoiseHeader">CTM Greener Choice</span>
          }
          @if (themeService.isScionEnv) {
            <span i18n="@@flightDetails_greenerChoiseHeader2">Greener Choice</span>
          }
        </div>
        <span class="sr-only"
          >This flight emits {{ flight?.greenerChoicePercentage | greenerPercentage }}% less CO2
          than the average for your search</span
        >
      </div>
    </section>
  }
  @if (!gmt) {
    <div class="flight_detail_container">
      <div class="flight_detail_header">
        <section class="container" (mouseleave)="safTT.close()">
          <div
            class="flight-saf"
            ngbTooltip="Sustainable Aviation Fuel Score"
            tabindex="0"
            #safTT="ngbTooltip"
            (mouseenter)="safTT.open()"
            (focus)="safTT.open()"
            (blur)="safTT.close()"
            triggers="manual"
          >
            <img
              alt=""
              class="flightDetails_safLogo"
              src="https://images.sabscorp.com/images/enterprise/SAF-Icon.svg"
            />
            <b class="saf-text">SAF: {{ flight.safRating }}</b>
            <span class="visuallyhidden" i18n="@@safTooltip">Sustainable Aviation Fuel Score</span>
          </div>
        </section>
        <div
          class="flight_detail_info"
          (click)="showDetail = !showDetail"
          role="button"
          [attr.aria-expanded]="showDetail"
          attr.aria-controls="flight-detail-expended"
          tabindex="0"
          (keydown.enter)="showDetail = !showDetail"
          id="flight-display-show-details-{{ flightIndex }}"
          [attr.aria-label]="'Show trip details and fares for ' + getTicketExpandAriaLabel()"
        >
          <b class="detail-accordion">{{
            (showDetail ? 'Collapse' : 'Show trip details & fares') | translate
          }}</b>
          <i [ngClass]="showDetail ? 'ico-tri-up' : 'ico-tri-down'" aria-hidden="true"></i>
        </div>
      </div>
      @if (showDetail) {
        <div class="flight_detail_showdetail" id="flight-detail-expended-3">
          <app-flight-journey-detail
            (selectedMultiCityFlight)="selectedMultiCityFlight.emit($event)"
            (deselectMultiCityFlight)="deselectMultiCityFlight.emit($event)"
            [selectedItemsId]="selectedItemsId"
            [disableItems]="disableItems"
            [isExchange]="isExchange"
            [isPricingExchange]="isPricingExchange"
            [isDualFlight]="isDualFlight"
            [isDualReturn]="isDualReturn"
            (addToBasketEvent)="selectedFlight($event)"
            [flightDetail]="flight"
            [fares]="combinedFlight.flights"
            [search]="search"
            [searchParams]="searchParams"
            [flightIndex]="flightIndex"
            [visuallyHiddenLabel]="getTicketExpandAriaLabel(combinedFlight)"
            [isUnavailableDueToTime]="isUnavailableDueToTime"
          ></app-flight-journey-detail>
        </div>
      }
    </div>
  }
</div>
<ng-template #greenChoiceTooltip>
  <span i18n="@@flightDetails_greenerChoiseText">
    This flight emits
    <em>{{ flight?.greenerChoicePercentage | greenerPercentage }}% less CO<sub>2</sub> </em>
    than the average for your search
  </span>
</ng-template>

<ng-template #hiddenStopsTooltip class="hiddenStops">
  <span i18n="@@flightDetails_hidden_stops">
    This flight has a hidden stop but does not require you to leave the aircraft.
  </span>
  @for (hiddenDetail of allHiddenStops; track hiddenDetail) {
    <div>
      <br />
      <b>{{ hiddenDetail.originAirport }} to {{ hiddenDetail.airport }}:</b>
      Depart {{ hiddenDetail.dateTimeDeparting | sabsTimePipe }} Arrive
      {{ hiddenDetail.arrivalTime }} <br />
      {{ hiddenDetail.elapsedLayoverTime }} minute layover<br />
      <b>{{ hiddenDetail.airport }} to {{ hiddenDetail.destinationAirport }}:</b>
      Depart {{ hiddenDetail.departureTime }} Arrive
      {{ hiddenDetail.dateTimeArriving | sabsTimePipe }} <br />
    </div>
  }
</ng-template>
